<mat-card appearance="outlined" class="cur-card">
  <mat-card-header>
    <mat-card-title>請求内訳情報</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>売掛金番号</mat-label>
        <input matInput id="cdtmnyNo" value="{{urikakekinInfo.cdtmnyNo}}" class="font-color-display-only" disabled />
      </mat-form-field>
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>売掛金種別</mat-label>
        <input matInput id="srvClsfyCodeAname" value="{{urikakekinInfo.srvClsfyCodeAname}}"
          class="font-color-display-only" disabled />
      </mat-form-field>
    </div>
  </mat-card-content>
</mat-card>